import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { get, isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

import { parseUrlParams } from '../../utils/parseUrlParams';
import { newCheckInAction } from '../../actions/navigation';
import Header from '../../components/Header';
import imgComplete from '../../assets/icons/mobile-phone-icon.svg';
import { ricWorkflowName } from '../../utils/appConstants';
import ApplicationId from '../../components/ApplicationId';

const OfferConfirmed = (props) => {
  const { navigate, checkinData } = props;
  const match = useParams();
  const workflowType = get(match, 'workflowType') === 'luwa' ? 'dtm-luwa' : get(match, 'workflowType');
  const ricWorkFlow = workflowType === ricWorkflowName;

  useEffect(() => {
    const params = parseUrlParams(window.location.search);

    if (isEmpty(checkinData)) {
      props.newCheckInAction({
        workflowType: workflowType || 'dtm-luwa',
        key: get(params, 'key'),
      });
    }
  }, [checkinData]);

  return (
    <div className="transition-item wrapper v-center">
      <Header navigate={navigate} />
      {get(checkinData, 'attributes.entityId') ? (
        <ApplicationId id={get(checkinData, 'attributes.entityId')} style={{ marginTop: 15 }} />
      ) : null}
      <div className="content">
        <img src={imgComplete} alt="Declined" width="100px" />
        <h1>Please Check Your Phone.</h1>
        <h3 className="mb-1">
          A text message has been sent to proceed with your
          {ricWorkFlow ? ' application.' : ' loan.'}
        </h3>
        <p>
          Your
          {' '}
          {ricWorkFlow ? 'contract' : 'loan'}
          {' '}
          approval is subject to identity and income verification.
        </p>
      </div>
    </div>
  );
};

OfferConfirmed.propTypes = {
  navigate: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
  newCheckInAction: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  checkinData: state.screen.checkinData,
});

const mapDispatchToProps = {
  newCheckInAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(OfferConfirmed);
